import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Button from '../../components/button';
import H1 from '../../components/h1';
import Input from '../../components/input';
import Spacer from '../../components/spacer';
import { getMyAccounts, getUserMeta } from '../../api/queries';
import AppState from '../../store/appstate';
import Loading from '../../layouts/loading';
import ApiErrorMessage from '../../components/apiErrorMessage';

function AddAccount1() {
  const { t } = useTranslation('onboarding');
  const history = useHistory();
  const userMeta = getUserMeta();
  const addAccountName = AppState.useState((s) => s.addAccount.accountName);
  const myAccounts = getMyAccounts();
  const [err, setErr] = useState(null);
  const [valid, setValid] = useState(true);
  // useEffect(() => {
  //   if (myAccounts.isSuccess && myAccounts.data === null && userMeta.isSuccess && ['Artist', 'Vocalist', 'DJ', 'Band Member'].includes(userMeta?.data?.role)) {
  //     // and they are an artist
  //     // set band name
  //     // and
  //     // skip to next section
  //     AppState.update((s) => { s.addAccount.accountName = userMeta.data.account_name; });
  //     history.push('/add-account-2');
  //   }
  // }, [myAccounts, userMeta]);

  if (myAccounts.isLoading || userMeta.isLoading) {
    return <Loading />;
  }

  const doesNameAlreadyExist = (name) => myAccounts.data.artistaccounts.find(
    (a) => a.accountname.toLowerCase() === name.toLowerCase().trim(),
  );

  const checkValid = (text) => {
    setValid(true);
    let error = '';
    // pass regex check
    if (text.length > 199) {
      error = t('regex:artist-account-name-char-error');
      setValid(false);
    }
    setErr(error);
  };

  const checkErrors = () => {
    setErr(null);
    if (myAccounts.data) {
      if (doesNameAlreadyExist(addAccountName)) {
        setErr(t('regex:artist-name-already-exists-error'));
        return;
      }
    }
    history.push('/add-account-3');
  };

  let title = t('onboarding:artist-title');
  let placeholder = t('onboarding:artist-name-placeholder');
  switch (userMeta?.data?.role) {
    case 'Artist':
    case 'DJ':
    case 'Songwriter':
    case 'Producer':
      title = t('onboarding:artist-title');
      placeholder = t('onboarding:artist-name-placeholder');
      break;
    case 'Band':
      title = t('onboarding:band-title');
      placeholder = t('onboarding:band-name-placeholder');
      break;
    case 'Label':
    case 'Manager':
      title = t('onboarding:add-artist-to-account');
      placeholder = t('onboarding:artist-name-placeholder');
      break;
    default:
      break;
  }

  return (
    <div className="container mx-auto">
      <div className="flex flex-col justify-center items-center text-white p-4 text-center min-h-screen-minus-footer">
        {userMeta.isSuccess && (
          <>
            <H1>{title}</H1>
            <Spacer />
            <div className="w-full lg:w-1/3">
              <Input
                placeholder={placeholder}
                value={addAccountName}
                onBlur={(e) => checkValid(e.target.value)}
                onChange={(e) => AppState.update((s) => {
                  s.addAccount.accountName = e.target.value;
                })}
              />
            </div>
            <Spacer />
            <ApiErrorMessage apiError={err} />
            <Button disabled={!addAccountName || !valid} onClick={() => checkErrors()}>
              {t('onboarding:next-step-button')}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

export default AddAccount1;
